<template>
    

    
  <v-container>
    <v-card-title >{{titulo}}</v-card-title>
<v-divider></v-divider><br>
    <div v-if="filasFiltradas.length === 0">
      <p>No hay datos disponibles.</p>
    </div>

    <div v-else>
      <v-row>
        <v-col cols="12">
          <table class="my-cashflow-table">
            <thead>
              <tr>
                <th>{{this.$t('simulacion.modulo.resultado.periodo-tarifario.anio')}}</th>
                <th v-for="(periodo, idx) in periodos" :key="idx">
                  {{ periodo.nombre }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fila, index) in filasFiltradas" :key="index">
                <td>{{ fila.Year }}</td>
                <td v-for="(periodo, idx) in periodos" :key="idx">
                  {{ parseFloat(fila[periodo.clave] || 0).toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </div>
  </v-container>
  
</template>

<script>
export default {
  name: "ComponenteResultadoPeriodosTarifarios",
  props: {
    datos_sal_an: {
      type: Array,
      required: true,
    },
    anio_inicio: {
    type: Number,
    required: true,
  },
  anio_fin: {
    type: Number,
    required: true,
  },
  prefix:{
    type:String,
    default:null,
  },
  titulo:{
    type:String,
    default:null,
  }
  },
  computed: {
    filasFiltradas() {
    return this.datos_sal_an
      .filter(fila => {
        const año = typeof fila.Year === 'string' && fila.Year.startsWith('a')
          ? parseInt(fila.Year.substring(1))
          : parseInt(fila.Year);
        return (
          !isNaN(año) &&
          año >= this.anio_inicio &&
          año <= this.anio_fin &&
          fila.Year.toLowerCase() !== "total"
        );
      })
      .map(fila => ({
        ...fila,
        Year: typeof fila.Year === 'string' && fila.Year.startsWith('a')
          ? fila.Year.substring(1)
          : fila.Year
      }));
  }
  },
  watch:{
    prefix:{
    }
  },
  mounted(){
    if(this.prefix){
      let extra_mw=''
      if (this.prefix=='PCONT_t'){
        extra_mw='_mw'
      }
      const per=[]
          for(let i=1; i<7;i++){
            const row={
              nombre:this.$t('simulacion.modulo.resultado.periodo-tarifario.p'+i+extra_mw) , clave:this.prefix+i
            }
            per.push(row)
          }
          this.periodos=per
    }
  },
  data() {
    return {
      periodos: [
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p1'), clave: "PCONT_t1" },
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p2'), clave: "PCONT_t2" },
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p3'), clave: "PCONT_t3" },
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p4'), clave: "PCONT_t4" },
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p5'), clave: "PCONT_t5" },
        { nombre: this.$t('simulacion.modulo.resultado.periodo-tarifario.p6'), clave: "PCONT_t6" },
      ],
    };
  }
};
</script>

<style scoped>
.my-cashflow-table {
  width: 100%;
  border-collapse: collapse;
}

.my-cashflow-table th,
.my-cashflow-table td {
  border: 1px solid #073a4e;
  padding: 8px;
  text-align: right;
}

.my-cashflow-table th {
  background-color: #87d7f7;
  text-align: center;
}

.my-cashflow-table td:first-child,
.my-cashflow-table th:first-child {
  text-align: center;
}
</style>
